// Output-mapper registry key for the NetSuite integration owner (invoice document type).
export const NETSUITE_OUTPUT_MAPPER_KEY = 'netsuite.invoice';
